<template>
    <div class="fixed top-0 left-0 z-50 w-full overflow-y-auto md:inset-0 h-full bg-black bg-opacity-50 flex justify-center items-center">
        <div class="m-auto">
            <slot v-bind="$props"></slot>
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        this.$root.disableBodyScroll();
    },

    unmounted() {
        this.$root.enableBodyScroll();
    },
}
</script>